import * as React from 'react';
import classNames from 'classnames';
import './radioButton.module.scss';

type Props = {
    checked: boolean;
    onCheck: (nextState: boolean) => any;
};

export const RadioButton = ({ checked, onCheck }: Props) => {
    return <div styleName={classNames('radio-button', { checked: checked })} onClick={() => onCheck(!checked)} />;
};
